import { combineClasses } from "@citychallenge/core";
import { FC } from "react";

import { usePagesUi } from "../../core/pages-ui-context";
import styles from "./section.module.scss";

export interface SectionProps {
  darkBackground?: boolean;
}

export const Section: FC<SectionProps> = ({ children, darkBackground }) => {
  const isPages = usePagesUi();

  return (
    <section
      className={combineClasses(
        styles.section,
        // In the pages runtime the section is a transparent, full-width shell:
        // the detail content supplies its own brandkit surface/border, so the
        // section drops its own background, border and centered-width cap.
        isPages ? styles.pages : undefined,
        darkBackground && !isPages ? styles.darkBackground : undefined
      )}
    >
      <div
        className={combineClasses(
          styles.sectionContent,
          isPages ? styles.sectionContentPages : undefined
        )}
      >
        {" "}
        {children}
      </div>
    </section>
  );
};
